var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('v-icon',{key:_vm.isDark,on:{"click":function($event){_vm.isDark = !_vm.isDark}}},[_vm._v(" "+_vm._s(_vm.isDark ? 'mdi-weather-sunny' : 'mdi-weather-night')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }